<template>
  <FormulateForm 
        invalid-message="Not all fields were filled out properly"
        :name="currentSession.activeStepKey"  
        v-model="formAnswers" 
        @submit="submitHandler" 
        :key="currentSession.activeStepKey">
    <initio-formulate :elements="schema" :form-answers="formAnswers" />
    <slot name="form_bottom"></slot>
    <hr v-if="!hideSubmit" class="form-footer-submit-divider" />
    <FormulateErrors />
    <FormulateInput v-if="!hideSubmit"
      type="submit"
      label="Continue"
    />

    <slot name="form_footer"></slot>
    
    <slot name="errors"></slot>

    <div v-if="envNotProd && ! manuallyShowDebug && !hideManualDebugBox" class="box mt-5">
      <button v-on:click="manuallyShowDebug = true; hideManualDebugBox = true;" class="button is-danger">SHOW DEBUG</button>
      <button v-on:click="hideManualDebugBox = true;" class="button is-danger is-light is-pulled-right">X</button>
    </div>
    <div class="form-debug" v-if="envNotProd && manuallyShowDebug">
      <pre>Current Step data: {{ formAnswers }}</pre>
      <pre>All step data: {{ allAnswers }}</pre>
      <pre>Flattened Answers: {{ flattenedAnswers }}</pre>
      <pre>Answer Labels: {{ labels }}</pre>
    </div>
  </FormulateForm>
</template>

<script>

import InitioFormulate from './InitioFormulate.vue'
import cloneDeep from "lodash.clonedeep";
import debounce from "lodash.debounce";
import isEqual from "lodash.isequal";
import { mapGetters } from 'vuex'

export default {
  components: {
    InitioFormulate
  },
  props: {
    hideSubmit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      localActiveStep: '',
      formAnswers: {},
      manuallyShowDebug: false,
      hideManualDebugBox: false,
    }
  },
  methods: {
    submitHandler(answers) {
      this.$store.commit('updateAnswers', { localActiveStep: this.localActiveStep, answers: answers})

      this.$emit('submit-handler');
    },
      
    loadDataInForm() {

      // console.log('loadDataInForm()');

      this.formAnswers = cloneDeep(this.currentSession.answers[this.currentSession.activeStepKey]);

      this.$formulate.setValues(this.currentSession.activeStepKey);
    },

    // Put the local state into the store
    updateFormDataToState:   debounce(function(newFormAnswers, localActiveStep) {
          // Dont update the state if no local step ( don't want to update the state after submit / step change  etc )

          //console.log()

          if( localActiveStep ){
            // console.log('debounce answers changed');
            const formAnswersLocal = cloneDeep(newFormAnswers);
            this.$store.commit('updateAnswers', { localActiveStep: this.localActiveStep, answers: formAnswersLocal});
          }
      }, 150) // Keep the debounce low, as this effects conditional questions from appearing
  },
  computed: {
    ...mapGetters({
      currentSession: 'currentSession', 
      flattenedAnswers: 'flattenedAnswers',
      envNotProd: 'envNotProd'
    }),
    allAnswers: {
      get () {
        return this.currentSession.answers;
      }
    },
    labels: {
      get () {
        return this.currentSession.labels;
      }
    },
    schema: {
      get () {
        return this.currentSession.schema
      },
      set (value) {
        this.$store.commit('updateSchema',value)
      }
    }

  },
  watch: {
    // Update the store with the local component state on change with debounce
    formAnswers: {
      deep: true,
      handler (newVal) {

        // console.warn(newVal);

        // debounce here ?
        // console.log('watch triggered');

        //if ( !isEqual( newVal, oldVal) ) {
          //console.log('update triggered');
        this.updateFormDataToState(newVal, this.localActiveStep);
        //}
      }
    }
  },
  beforeMount(){
    // this.formAnswers = {}; // Clear any answers ( prevents previous step data leaking in)
    this.localActiveStep = this.currentSession.activeStepKey;

    this.loadDataInForm();
  },
  name: 'initio-formulate-base'
}

</script>


<style lang="scss">

  div[data-type="submit"] {
    display:flex;
    justify-content: flex-end;
  }

</style>

<style scoped lang="scss">
  .form-debug {
    z-index: 10;
    margin-top: 10px;
    pre {
      white-space: pre-wrap;
    }
  }

  hr {
    height:0;
    border:0;
    background:0;
    margin:0;
    border-top:1px solid rgba(223, 227, 232, 1);
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .form-debug {
    margin-top:3rem;
    @include mobile(){
      display: none;
    }
  }
</style>